import React from "react";
import { AiFillGithub } from "react-icons/ai";
import {
  FiFacebook,
  FiGithub,
  FiInstagram,
  FiLinkedin,
  FiTwitter,
} from "react-icons/fi";
import "./Sidebar.css";

const Sidebar = () => {
  return (
    <div>
      <div className=" fixed bottom-0 left-0 invisible md:visible">
        <ol className=" font-mono text-sm flex flex-col text-[#ccd6f6] h-96 gap-7 items-center justify-end w-28">
          <li className="hover:text-green-300 hover:scale-150">
            <a href="https://github.com/assegidasefa" target="_blank">
              <FiGithub size={20} />
            </a>
          </li>
          <li className="hover:text-green-300 hover:scale-150">
            <a
              href="https://www.linkedin.com/in/assegid-assefa"
              target="_blank"
            >
              <FiLinkedin size={20} />
            </a>
          </li>
          <li className="hover:text-green-300 hover:scale-150">
            <a href="https://www.instagram.com/assefaassegid/" target="_blank">
              <FiInstagram size={20} />
            </a>
          </li>

          <li className="hover:text-green-300 hover:scale-150">
            <a href="https://twitter.com/assegidassefa7" target="_blank">
              <FiTwitter size={20} />
            </a>
          </li>
          <li className="hover:text-green-300 hover:scale-150">
            <a
              href="https://www.facebook.com/assegid.assefa.71"
              target="_blank"
            >
              <FiFacebook size={20} />
            </a>
          </li>
          <li className="mt-20">
            <span class=" px-[1px] py-20 align-top text-[#ccd6f6] bg-[#ccd6f6] "></span>
          </li>
        </ol>
      </div>
      <div className="fixed bottom-0 right-0 invisible md:visible">
        <ol className=" font-mono text-sm flex flex-col text-[#ccd6f6] h-96 gap-7 items-center justify-end w-28">
          <p className="mode align-top">assegidassefa7@gmail.com</p>
          <li className="mt-20">
            <span class=" px-[1px] py-20 align-top text-[#ccd6f6] bg-[#ccd6f6] "></span>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default Sidebar;
